import { createLazyFileRoute } from "@tanstack/react-router";
import { OnboardingRoute } from "@vendor-app/v3/routes/Onboarding";

export const Route = createLazyFileRoute("/admin/onboarding")({
  component: OnboardingRoute,
});
